import React from "react";
import { Modal, Button, Row } from "antd";
import DangerIcon from "../../Icons/DangerIcon";
import SuccessIcon from "../../Icons/SuccessIcon";
import FailureIcon from "../../Icons/FailureIcon";

export default function DecisionConfirmationModal({
  modalDetails,
  callback,
  toggleModal,
  modalContent,
  activeParticipant,
}) {
  const { isVisible, type } = modalDetails;
  return (
    <div className="DecisionConfirmationModal">
      <Modal
        width="20%"
        visible={isVisible}
        onOk={callback}
        footer={false}
        closable={false}
        maskClosable={false}
      >
        <div className="warning-title-container">
          <DangerIcon />
          <span>
            <b>{modalContent[type]?.title}</b>
          </span>
        </div>
        <div className="decision-message-container">
          <p>
            {`${modalContent[type]?.text}`}{" "}
            <span>{`${activeParticipant.name}`}</span>?
          </p>
        </div>

        <div className="confirmation-button-container">
          <Button onClick={() => toggleModal()} className="cancel-btn">
            {modalContent[type]?.cancelButtonText}
          </Button>
          <Button onClick={() => callback()} className="delete-btn">
            {modalContent[type]?.confirmButtonText}
          </Button>
        </div>
      </Modal>
    </div>
  );
}
